import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * https://angular.io/guide/http#intercepting-all-requests-or-responses
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  INTERCEPTOR_SKIP_HEADER_AUTH: string;
  constructor() {
    this.INTERCEPTOR_SKIP_HEADER_AUTH = 'X-Skip-Interceptor-Auth';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /* Ignora el auth si contiene la cabecera indicada */
    if (req.headers.has(this.INTERCEPTOR_SKIP_HEADER_AUTH)) {
      const headers = req.headers.delete(this.INTERCEPTOR_SKIP_HEADER_AUTH);
      return next.handle(req.clone({ headers }));
    }
    // Get the auth header from the service.
    if (sessionStorage.getItem('authenticationToken')) {
      const authHeader = `Bearer ${sessionStorage.getItem('authenticationToken')}`;
      req = req.clone({ headers: req.headers.set('Authorization', authHeader) });
    }

    // Pass on the cloned request instead of the original request.
    return next.handle(req);
  }
}
